import { render, staticRenderFns } from "./MilestoneItem.vue?vue&type=template&id=7ed41c34&scoped=true"
import script from "./MilestoneItem.vue?vue&type=script&lang=js"
export * from "./MilestoneItem.vue?vue&type=script&lang=js"
import style0 from "./MilestoneItem.vue?vue&type=style&index=0&id=7ed41c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed41c34",
  null
  
)

export default component.exports